import { v4 as uuidv4 } from 'uuid';
// Utility to get items from sessionStorage
export function getSessionStorageItem(key: string): string | null {
  return sessionStorage.getItem(key);
}

// Utility to set items in sessionStorage
export function setSessionStorageItem(key: string, value: string): void {
  sessionStorage.setItem(key, value);
}

// Refresh the session (e.g., generate a new session ID)
export function refreshSession(): string {
  const newSessionID = uuidv4(); // Generate a new session ID
  setSessionStorageItem('session_id', newSessionID); // Save the new session ID
  return newSessionID;
}

// Clear the session (manually or on logout)
export function clearSession(): void {
  sessionStorage.removeItem('session_id');
}

// The app-bridge product_type lives in localStorage, not sessionStorage: the
// OS flipping light/dark can recreate the native webview, which drops
// sessionStorage but reloads the same URL (with no product_type on it). Every
// /app-bridge open overwrites it, so a stale value never outlives the next open.
export function setProductTypeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* localStorage unavailable */
  }
}

export function getProductTypeStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
